import React, { Component } from 'react'
import './MenuBar.scss'
import { push as Menu } from 'react-burger-menu'
import NavLink from 'Components/NavLink'
import User from 'EurestoClass/User'
import Grid from '@material-ui/core/Grid'

import MyMenu from './Menu'

import Timer from 'Components/Timer'
import Constants from 'EurestoFonction/Constants'
import DataComponent from 'EurestoComponents/DataComponents'
import { browserHistory } from 'react-router'

import Utils from 'EurestoFonction/Utils'

import ScrollBar from 'Components/ScrollBar'

export default class MenuBar extends Component {
  styles1 = {
    bmBurgerButton: {
      position: 'fixed',
      //padding: '0.5px 0.5px 0.5px 0.5px',
      //color: 'white',
      top: 7.5,
      zIndex: 100,
      left: 10,
      fontSize: 25,
    },
    bmMenuWrap: {
      //position: 'fixed',
      width: '200px',
      maxHeight: '100vh',
      zIndex: 1,
      marginTop: 0,
      borderRight: '1px solid rgba(169,169,169,.4)',
      boxShadow: '0px 10px 5px #A9A9A9',
      //overflow: 'hidden'
    },
    bmCrossButton: {
      fontSize: 25,
      position: 'fixed',
      top: 7.5,
      zIndex: 2,
      left: 170,
    },
    bmMenu: {
      //padding: '0 0 2.5em 0',
      fontSize: '1.15em',
      maxHeight: '100vh',
      overflow: 'hidden'
      //marginTop: 40
    },
  }

  constructor(props) {
    super(props)
    this.state = {
      expanded: {},
      key: Utils.getRandomNumber(),
      activeItem: 0,
      isOpen: true
    }
  }

  changeCssPageWrap = () => {
    if (this.state.isOpen) {
      $('#page-wrap').css({
        'width': 'calc(100vw - ' + $('#MenuBarModule > div > .bm-menu-wrap').css('width') + ')',
        'max-width': 'calc(100vw - ' + $('#MenuBarModule > div > .bm-menu-wrap').css('width') + ')',
        'margin-left': 'calc(' + $('#MenuBarModule > div > .bm-menu-wrap').css('width') + ')',
        'transform': 'none'
      })
      $('#MenuContainer').css({
        'width': 'calc(100vw - ' + $('#MenuBarModule > div > .bm-menu-wrap').css('width') + ')',
        'max-width': 'calc(100vw - ' + $('#MenuBarModule > div > .bm-menu-wrap').css('width') + ')',
        'margin-left': 'calc(' + $('#MenuBarModule > div > .bm-menu-wrap').css('width') + ')',
        'transform': 'none'
      })
    } else {
      $('#page-wrap').css({
        'width': '100vw',
        'max-width': '100vw',
        'margin-left': 0,
        'transform': 'none'
      })
      $('#MenuContainer').css({
        'width': '100vw',
        'max-width': '100vw',
        'margin-left': 0,
        'transform': 'none'
      })
    }
  }

  isOpenMenu = (state) => {
    this.changeCssPageWrap()
    this.setState({
      isOpen: state.isOpen
    })
    return state.isOpen
  }

  componentDidMount() {
    this.changeCssPageWrap()
  }

  openSubMenu = (elem) => {
    $('#icon-square-' + elem).toggleClass('ei-commun_carre_plus ei-commun_carre_moins')
    this.setState({
      expanded: {
        ...this.state.expanded,
        [elem]: !this.state.expanded[elem]
      }
    })
  }

  checkSsMenuSmallItem(menu, index) {
    if (menu.ssMenu !== undefined) {
      User.OpenMenuBar.set(true)
      this.setState({
        key: Utils.getRandomNumber()
      })
    }
  }

  ssMenuOrItem = (menu, index, menuIndex = 0) => (menu.autorisation === undefined || menu.autorisation()) &&
    <div key={index + '_' + menuIndex}
      className={menuIndex === 0 && 'MainMenuItem'}>
      <Grid container spacing={0} justify={'center'} alignItems={'center'} wrap={'nowrap'} alignContent={'center'}>
        <NavLink key={index + '_' + menuIndex} active
          style={{ borderTopRightRadius: 5, borderBottomRightRadius: 5 }}
          className={'ssMenu menu-item ' + (menu.link === window.location.pathname && 'page-layout__nav-item--active' || '')}
          target={typeof menu.link !== "string" && "_blank"}
          to={typeof menu.link === "string" && menu.link} href={typeof menu.link !== "string" && menu.link(localStorage.getItem('token'))}>
          <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
            <Grid item xs={12} style={{ margin: 0, padding: 0, paddingRight: 5 }}>
              <Grid container spacing={0} style={{ margin: 0, padding: 0, height: 20 }} justify={'flex-start'}
                alignItems={'center'} className={'EurestoText--text fa-x'}
                alignContent={'center'}>
                <i className={menu.icon} style={{ padding: '0px 5px 0px 2.5px' }} />{menu.label}
              </Grid>
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
    </div>

  etablissementLibelle = () => {
    return User && User.Entite && User.Entite.get() && (User.User.get().id === 3 && User.TypeAccess.get(Constants.access.EURESTO) && 'Sud Mécanographie' || User.Entite.get().libelle) || ''
  }

  handleClickLogo = () => {
    browserHistory.push({
      pathname: '/'
    })
  }

  render() {
    this.changeCssPageWrap()
    const libelleEts = this.etablissementLibelle()
    return (
      <div id="MenuBarModule" key={this.state.key}>
        <Menu pageWrapId={'body-page'} outerContainerId={'outer-container'} noOverlay={true}
          isOpen={this.state.isOpen} onStateChange={this.isOpenMenu}
          styles={this.styles1}
          burgerButtonClassName={this.state.isOpen ? '' : 'ei-commun_burger_menu EurestoPrimary--text'}
          crossButtonClassName={'ei-commun_burger_menu EurestoText--text'}>
          <Grid className={'bm-menu-img'} container style={{
            margin: 0, padding: 0
          }} spacing={0} direction={'row'} justify={'center'}
            alignItems={'center'}>
            <Grid onClick={this.handleClickLogo} container
              className={'EurestoPrimary'}
              style={{
                margin: 0, padding: 0, cursor: 'pointer', width: '100%', height: 40,
                //borderBottom: '1px solid #A9A9A9',
                //background: '#E9E9E9'
              }} spacing={0}
              justify={'flex-start'} alignItems={'center'}>
              <Grid item style={{ margin: 0, padding: 0, width: 40 }}>
                {User && User.Entite && User.Entite.get() && User.Entite.get().media_lien &&
                  <div style={{
                    postion: 'relative',
                    padding: 2.5,
                    width: 35,
                    maxWidth: 35
                  }}>
                    <DataComponent
                      avatarStyle={{ borderRadius: 5, maxWidth: 35, maxHeight: 35 }}
                      disabled={true}
                      type={Constants.typeSaisie.Picture}
                      defineData={true}
                      data={{ id: User.Entite.get().media_id, lien: User.Entite.get().media_lien }}
                      object={{
                        picture: { id: User.Entite.get().media_id, lien: User.Entite.get().media_lien },
                      }} />
                  </div>
                  ||
                  <div style={{
                    marginLeft: 15,
                  }}>
                    <span className={'ei-logo_BE EurestoSecondary--text'} style={
                      {
                        fontSize: 25,
                        zIndex: 1,
                        fontWeight: 12,
                        position: 'absolute',
                        top: 7,
                        left: 11
                      }
                    } />
                    {
                      User.User.get().id === 3 && User.TypeAccess.get(Constants.access.EURESTO) && <span className={'EurestoText--text'} style={
                        {
                          position: 'absolute',
                          fontSize: 35,
                          fontWeight: 'bold',
                          fontStyle: 'italic',
                          top: -10,
                          //fontWeight: 12,
                          zIndex: 2,
                          left: 5,
                        }
                      }>R</span> || <span className={'ei-logo_E EurestoText--text'} style={
                        {
                          position: 'absolute',
                          fontSize: 30,
                          top: 4,
                          fontWeight: 12,
                          zIndex: 2,
                          left: 5,
                        }
                      } />}
                  </div>
                }
              </Grid>
              <Grid item xs style={{ margin: 0, padding: 0, height: 40, width: 130 }}
                className={'EurestoText--text'}>
                <Grid container style={{ height: 40 }} spacing={0} direction={'column'} justify={'center'}
                  alignItems={'flex-start'}>
                  <span style={{
                    margin: 0,
                    padding: 0,
                    width: 130,
                    //height: 40,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'pre-wrap',
                    lineHeight: libelleEts.length > 20 && '14px' || '15px',
                    //maxHeight: 40,
                    fontSize: libelleEts.length > 20 && '80%' || '100%',
                    display: 'block'
                  }}>{libelleEts}</span>
                </Grid>
              </Grid>
            </Grid>
            <Grid className={'EurestoPrimaryOpacity'} item xs={12} style={{
              margin: 0,
              padding: 0,
              zIndex: 1,
              //backgroundColor: 'rgba(50, 30, 92, .7)',
              width: '100%',
              borderBottom: '2px solid rgba(0,0,0,0.50)',
              overflow: 'hidden',
            }}>
              <div style={{
                overflow: 'hidden'
              }}>
                <ScrollBar
                  maxHeight={User.CalculHeight.getHeightWanted(!User.CalculHeight.getIsConnectedAs() && 31 || 0)}>
                  {MyMenu.map((mainMenu, index) => {
                    return ((!mainMenu.module || mainMenu.module.reduce((isModuleIn, option) => isModuleIn || EurestoOption(option), false)) && (mainMenu.autorisation === undefined || mainMenu.autorisation()) &&
                      <div key={index + '_main_menu'} style={{ paddingRight: 2.5 }}>
                        <Grid container spacing={0}
                          className={'EurestoPrimary--text EurestoText'}
                          style={{
                            margin: 0,
                            fontSize: 17,
                            position: 'relative',
                            padding: '2.5px 0px 2.5px 2.5px',
                            borderTopRightRadius: 5,
                            borderBottomRightRadius: 5
                          }}
                          justify={'center'} alignItems={'center'} alignContent={'center'}>
                          <Grid item xs={12} style={{ margin: 0, padding: 0, paddingRight: 5, height: '100%' }}>
                            <Grid container spacing={0} justify={'flex-start'} alignItems={'center'}
                              alignContent={'center'}>
                              <i style={{ fontSize: 30, position: 'relative', zIndex: 1, paddingRight: 7 }}
                                className={'ei-commun_cadre EurestoPrimary--text'}>
                                <i style={{ fontSize: 20, position: 'absolute', top: 5, left: 5, zIndex: -1 }}
                                  className={mainMenu.icon + ' EurestoSecondary--text'} />
                              </i>{mainMenu.label}
                            </Grid>
                          </Grid>
                          {
                            mainMenu.add &&
                            <NavLink
                              className={'EurestoPrimary--text fa fa-' + mainMenu.add.icon + ' fa-x ' + (mainMenu.add.link === window.location.pathname && 'EurestoSecondary--text' || '')}
                              style={{ borderRadius: '50%', padding: 5, fontSize: 12, margin: 5, fontWeight: 'bold' }}
                              to={mainMenu.add.link}>
                            </NavLink>
                          }
                        </Grid>
                        {mainMenu.menu.map((menu, index) => {
                          return <div key={index + '_sub_menu'} style={{ paddingRight: 2.5 }}>
                            <div>{this.ssMenuOrItem(menu, index)}</div>
                            <span style={menu.link === window.location.pathname && menu.component && {
                              visibility: 'visible',
                              opacity: 1,
                              transition: 'visibility 3s, opacity 0.5s linear'
                            } || {
                              visibility: 'hidden',
                              opacity: 0,
                              transition: 'visibility 0s, opacity 0.5s linear'
                            }
                            }>
                              {menu.link === window.location.pathname && menu.component && menu.component()}
                            </span>
                          </div>
                        })
                        }
                      </div>)
                  })}
                </ScrollBar>
              </div>
            </Grid>

            <div className="infosEuresto EurestoPrimaryOpacity EurestoText--text"
              style={{
                padding: 5,
                borderTop: '1px solid rgba(255,255,255,0.20)',
                height: 31,
                maxHeight: 31
              }}>
              <div style={{
                postion: 'relative', display: 'inline'
              }}>
                <i className={'ei-logo_E'} style={
                  {
                    fontSize: 18,
                    zIndex: 1,
                    fontWeight: 10,
                    marginRight: -3
                  }
                } />
              </div>
              <strong className={'EurestoText--text'}>uresto</strong>
              <strong className={'EurestoSecondary--text'}>WEB</strong>
              <span className={'pull pull-right EurestoText--text'} style={{ fontSize: 11, marginTop: 7.5 }}>
                <Timer onlyClock={true} />
              </span>
            </div>
          </Grid>
        </Menu>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/App/Static/Menu/index.js